var React = require('react');

function CheckInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.7445 1.60269L9.5 10L0.255507 1.59303C0.0814272 1.40839 -0.00953711 1.17087 0.000792453 0.927954C0.011122 0.685034 0.121985 0.454602 0.311225 0.282703C0.500466 0.110805 0.754147 0.0101028 1.02157 0.000719838C1.289 -0.0086631 1.55048 0.0739641 1.75375 0.232091L9.5 7.27811L17.2463 0.241743C17.4495 0.0836164 17.711 0.000988283 17.9784 0.0103712C18.2459 0.0197542 18.4995 0.120457 18.6888 0.292356C18.878 0.464254 18.9889 0.694687 18.9992 0.937607C19.0095 1.18053 18.9186 1.41804 18.7445 1.60269Z","fill":"#0D4F7E"}));
}

CheckInline.defaultProps = {"width":"19","height":"10","viewBox":"0 0 19 10","fill":"none"};

module.exports = CheckInline;

CheckInline.default = CheckInline;
